import { getCamelOrSnakeCase } from '@/helpers';

export default function truthy(key) {
    return (item) => {
        return !!getCamelOrSnakeCase(item, key);
    };
}
